var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block blank double-padded", attrs: { id: _vm.selector } },
    [
      !_vm.settings.hide_header
        ? _c("the-header", {
            attrs: { settings: _vm.settings, certificate: _vm.certificate }
          })
        : _vm._e(),
      _c("div", { staticClass: "s-page-body" }, [
        _c("div", { staticClass: "s-table-box space-20" }, [
          !_vm.hideAll
            ? _c(
                "div",
                { staticClass: "content" },
                [
                  _vm.certificate.is_expired
                    ? _c(
                        "div",
                        { staticClass: "giftcertificate-attention-warning" },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("Certificate expired")) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.certificate.id
                    ? _c(
                        "div",
                        { staticClass: "giftcertificate-attention-info" },
                        [
                          _c("p", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "The certificate was created at {date}",
                                    { date: _vm.certificate.create_datetime }
                                  )
                                ) +
                                "\n                        "
                            ),
                            _vm.certificate.order_id > 0
                              ? _c("span", { staticClass: "inline" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("from the order")) +
                                      "\n                            "
                                  ),
                                  typeof _vm.settings.orders[
                                    _vm.certificate.order_id
                                  ] !== "undefined"
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              _vm.settings.backend_url +
                                              "shop/?action=orders#/orders/id=" +
                                              _vm.certificate.order_id +
                                              "/"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.settings.orders[
                                                  _vm.certificate.order_id
                                                ].id_encoded
                                              ) +
                                              "\n                                "
                                          ),
                                          _vm.settings.orders[
                                            _vm.certificate.order_id
                                          ].icon
                                            ? _c("i", {
                                                class:
                                                  _vm.settings.orders[
                                                    _vm.certificate.order_id
                                                  ].icon
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          "# " +
                                            _vm._s(_vm.certificate.order_id)
                                        )
                                      ])
                                ])
                              : _vm._e(),
                            _vm.certificate.create_contact_id > 0
                              ? _c("span", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("by user")) +
                                      "\n                            "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          _vm.settings.backend_url +
                                          "contacts/#/contact/" +
                                          _vm.certificate.create_contact_id
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getContactName(
                                              _vm.certificate.create_contact_id
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm.certificate.contact_id &&
                          _vm.certificate.contact_id.id !== undefined
                            ? _c("p", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("Only available for user")) +
                                    "\n                        "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        _vm.settings.backend_url +
                                        "contacts/#/contact/" +
                                        _vm.certificate.contact_id.id,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.getContactName(
                                            _vm.certificate.contact_id.id
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    !_vm.settings.is_frontend
                                      ? _c("base-icon16", {
                                          attrs: { id: "new-window" }
                                        })
                                      : _c("i", {
                                          staticClass: "gc-icon new-window"
                                        })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          !_vm.certificate.is_expired &&
                          _vm.certificate.lifetime_expired
                            ? _c("p", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("Expired")) +
                                    ": " +
                                    _vm._s(_vm.certificate.lifetime_expired) +
                                    ". " +
                                    _vm._s(
                                      _vm.$tc(
                                        "Left {$n} lifetime days",
                                        _vm.certificate.lifetime_left
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ])
                            : _vm._e(),
                          _vm.certificate.orders.length > 0
                            ? _c(
                                "div",
                                {
                                  class: {
                                    "giftcertificate-attention-warning":
                                      _vm.certificate.usage.type !== "multiple"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "certificate-orders" },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Certificate was used in the orders:"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._l(_vm.certificate.orders, function(
                                        order_id,
                                        index
                                      ) {
                                        return _c("div", { key: index }, [
                                          order_id < 0 &&
                                          typeof _vm.settings.orders[
                                            -1 * order_id
                                          ] !== "undefined"
                                            ? _c(
                                                "span",
                                                { staticClass: "shop-tooltip" },
                                                [
                                                  _c("base-icon16", {
                                                    attrs: { id: "clock" }
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Order is not paid"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          typeof _vm.settings.orders[
                                            Math.abs(order_id)
                                          ] !== "undefined"
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      _vm.settings.backend_url +
                                                      "shop/?action=orders#/orders/id=" +
                                                      Math.abs(order_id) +
                                                      "/"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.settings.orders[
                                                          Math.abs(order_id)
                                                        ].id_encoded
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                  _vm.settings.orders[
                                                    Math.abs(order_id)
                                                  ].icon
                                                    ? _c("i", {
                                                        class:
                                                          _vm.settings.orders[
                                                            Math.abs(order_id)
                                                          ].icon
                                                      })
                                                    : _vm._e()
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  "# " +
                                                    _vm._s(Math.abs(order_id))
                                                )
                                              ])
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "fields width100" },
                    [
                      _vm.certificate.code || _vm.settings.states
                        ? _c(
                            "div",
                            { staticClass: "field" },
                            [
                              _vm.certificate.code
                                ? _c(
                                    "wa-field",
                                    { attrs: { name: _vm.$t("Code") } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "gray-block" },
                                        [_vm._v(_vm._s(_vm.certificate.code))]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.settings.states
                                ? _c(
                                    "wa-field",
                                    { attrs: { name: _vm.$t("State") } },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.certificate.state_id,
                                              expression: "certificate.state_id"
                                            }
                                          ],
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.certificate,
                                                "state_id",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "0" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("Select the state")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._l(_vm.settings.states, function(
                                            state,
                                            index
                                          ) {
                                            return _c(
                                              "option",
                                              {
                                                key: index,
                                                domProps: { value: state.id }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(state.name) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.fields, function(field, findex) {
                        var _obj, _obj$1, _obj$2
                        return ((_vm.settings.is_frontend &&
                          parseInt(field.status)) ||
                          !_vm.settings.is_frontend) &&
                          (field.system_code || field.id)
                          ? _c(
                              "div",
                              { key: findex },
                              [
                                _vm.settings.is_frontend &&
                                field.type === "html"
                                  ? _c(
                                      "wa-field",
                                      {
                                        class: field.css_class,
                                        attrs: {
                                          name: field.name,
                                          hide_name: field.name === ""
                                        }
                                      },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(field.value)
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                field.type === "input:text" ||
                                field.type === "textarea"
                                  ? _c(
                                      "wa-field",
                                      {
                                        class: {
                                          required:
                                            _vm.settings.is_frontend &&
                                            parseInt(field.required),
                                          "hide-name":
                                            _vm.settings.is_frontend &&
                                            field.name === "",
                                          "field-error":
                                            _vm.$v.certificate[field.id] !==
                                              undefined &&
                                            _vm.$v.certificate[field.id].$error
                                        },
                                        attrs: {
                                          name: _vm.settings.is_frontend
                                            ? field.name
                                            : field.system_name,
                                          hide_name:
                                            _vm.settings.is_frontend &&
                                            field.name === "",
                                          hide_name_class: "width100"
                                        }
                                      },
                                      [
                                        field.text_before &&
                                        field.text_before !== "" &&
                                        _vm.settings.is_frontend
                                          ? _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  field.text_before
                                                )
                                              }
                                            })
                                          : _vm._e(),
                                        field.type === "input:text"
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.certificate[field.id],
                                                  expression:
                                                    "certificate[field.id]"
                                                }
                                              ],
                                              class:
                                                ((_obj = {}),
                                                (_obj[field.css_class] =
                                                  _vm.settings.is_frontend),
                                                _obj),
                                              attrs: {
                                                type: "text",
                                                placeholder: field.placeholder
                                              },
                                              domProps: {
                                                value: _vm.certificate[field.id]
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.certificate,
                                                    field.id,
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        field.type === "textarea"
                                          ? _c("base-textarea", {
                                              attrs: {
                                                locale: _vm.settings.locale,
                                                redactor: false
                                              },
                                              model: {
                                                value: _vm.certificate.message,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.certificate,
                                                    "message",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "certificate.message"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.$v.certificate[field.id] !==
                                          undefined &&
                                        _vm.hasError(
                                          _vm.$v.certificate[field.id],
                                          "required"
                                        )
                                          ? _c(
                                              "div",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Field is required")
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        field.text_after &&
                                        field.text_after !== "" &&
                                        _vm.settings.is_frontend
                                          ? _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  field.text_after
                                                )
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                field.system_code === "amount"
                                  ? _c(
                                      "wa-field",
                                      {
                                        class: {
                                          required:
                                            !_vm.certificate.products.length ||
                                            _vm.settings.system_settings
                                              .min_sum > 0,
                                          "field-error":
                                            _vm.$v.certificate.amount.$error
                                        },
                                        attrs: {
                                          name: _vm.settings.is_frontend
                                            ? field.name
                                            : field.system_name,
                                          hide_name:
                                            _vm.settings.is_frontend &&
                                            field.name === ""
                                        }
                                      },
                                      [
                                        field.text_before &&
                                        field.text_before !== "" &&
                                        _vm.settings.is_frontend
                                          ? _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  field.text_before
                                                )
                                              }
                                            })
                                          : _vm._e(),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.certificate.amount,
                                              expression: "certificate.amount"
                                            }
                                          ],
                                          staticClass: "width100px",
                                          class:
                                            ((_obj$1 = {}),
                                            (_obj$1[field.css_class] =
                                              _vm.settings.is_frontend),
                                            _obj$1),
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: _vm.certificate.amount
                                          },
                                          on: {
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.certificate,
                                                  "amount",
                                                  $event.target.value
                                                )
                                              },
                                              _vm.$v.certificate.amount.$touch
                                            ]
                                          }
                                        }),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.certificate.currency,
                                                expression:
                                                  "certificate.currency"
                                              }
                                            ],
                                            staticClass: "inherit",
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.certificate,
                                                  "currency",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            !_vm.settings.is_frontend &&
                                            !_vm.settings.is_backend_order_edit
                                              ? _c(
                                                  "option",
                                                  { attrs: { value: "%" } },
                                                  [_vm._v("%")]
                                                )
                                              : _vm._e(),
                                            _vm._l(
                                              _vm.settings.currencies,
                                              function(currency, index) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: index,
                                                    domProps: {
                                                      value: currency.code
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(currency.sign) +
                                                        " " +
                                                        _vm._s(currency.code) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        ),
                                        _vm.settings.amount_hints
                                          ? _c(
                                              "div",
                                              { staticClass: "mb" },
                                              _vm._l(
                                                _vm.settings.amount_hints,
                                                function(hint, index) {
                                                  return _c(
                                                    "a",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "inline-link mb right",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.certificate.amount =
                                                            hint.value
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _c("i", [
                                                          _vm._v(
                                                            _vm._s(hint.name)
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm.hasError(
                                          _vm.$v.certificate.amount,
                                          "required"
                                        )
                                          ? _c(
                                              "div",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Field is required")
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.hasError(
                                          _vm.$v.certificate.amount,
                                          "between"
                                        )
                                          ? _c(
                                              "div",
                                              { staticClass: "error" },
                                              [
                                                _vm.serverErrors.amount &&
                                                _vm.serverErrors.amount.message
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.serverErrors
                                                            .amount.message[0]
                                                        )
                                                      )
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Amount should be between {min} and {max}",
                                                            {
                                                              min:
                                                                _vm.$v
                                                                  .certificate
                                                                  .amount
                                                                  .$params
                                                                  .between.min,
                                                              max:
                                                                _vm.$v
                                                                  .certificate
                                                                  .amount
                                                                  .$params
                                                                  .between.max
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ])
                                              ]
                                            )
                                          : _vm._e(),
                                        field.text_after &&
                                        field.text_after !== "" &&
                                        _vm.settings.is_frontend
                                          ? _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  field.text_after
                                                )
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                field.system_code === "send" &&
                                ((_vm.settings.is_frontend &&
                                  Object.keys(field.variants).length) ||
                                  !_vm.settings.is_frontend)
                                  ? _c(
                                      "div",
                                      [
                                        Object.keys(field.variants).length > 1
                                          ? _c(
                                              "wa-field",
                                              {
                                                attrs: {
                                                  name: _vm.settings.is_frontend
                                                    ? field.name
                                                    : field.system_name,
                                                  hide_name:
                                                    _vm.settings.is_frontend &&
                                                    field.name === ""
                                                }
                                              },
                                              _vm._l(field.variants, function(
                                                variant,
                                                variantId
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: "variant" + variantId,
                                                    staticClass: "mb bottom"
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for:
                                                            "variant" +
                                                            variantId
                                                        }
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.certificate
                                                                  .send,
                                                              expression:
                                                                "certificate.send"
                                                            }
                                                          ],
                                                          class:
                                                            field.css_class,
                                                          attrs: {
                                                            type: "radio",
                                                            name: "send",
                                                            id:
                                                              "variant" +
                                                              variantId
                                                          },
                                                          domProps: {
                                                            value: variant.type,
                                                            checked: _vm._q(
                                                              _vm.certificate
                                                                .send,
                                                              variant.type
                                                            )
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.certificate,
                                                                "send",
                                                                variant.type
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              variant.name
                                                            ) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm._l(field.variants, function(
                                          variant,
                                          variantId2
                                        ) {
                                          return _c(
                                            "div",
                                            { key: variantId2 },
                                            [
                                              _vm.certificate.send === "post" &&
                                              variant.type === "post"
                                                ? _c(
                                                    "wa-field",
                                                    {
                                                      staticClass:
                                                        "address-block",
                                                      attrs: {
                                                        name: _vm.settings
                                                          .is_frontend
                                                          ? variant.name
                                                          : _vm.$t("Address"),
                                                        hide_name:
                                                          _vm.settings
                                                            .is_frontend &&
                                                          variant.name === ""
                                                      }
                                                    },
                                                    [
                                                      _vm.settings.is_frontend
                                                        ? _c("div", {
                                                            staticClass:
                                                              "mb bottom",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                field.before_address_text
                                                              )
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "address-item",
                                                          class: {
                                                            "is-loading":
                                                              _vm.loadingStatus
                                                                .regions,
                                                            required: true,
                                                            "field-error":
                                                              _vm.$v.certificate
                                                                .post.country
                                                                .$error
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "small grey"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Country"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .certificate
                                                                      .post
                                                                      .country,
                                                                  expression:
                                                                    "certificate.post.country"
                                                                }
                                                              ],
                                                              attrs: {
                                                                disabled:
                                                                  _vm
                                                                    .loadingStatus
                                                                    .regions
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      _vm
                                                                        .certificate
                                                                        .post,
                                                                      "country",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    _vm.loadRegions()
                                                                    _vm.$v
                                                                      .certificate
                                                                      .post
                                                                      .country
                                                                      .$touch
                                                                  }
                                                                ]
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Select country"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._l(
                                                                _vm.countries,
                                                                function(
                                                                  country,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key: index,
                                                                      domProps: {
                                                                        value:
                                                                          country.iso3letter
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          country.name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          ),
                                                          _vm.hasError(
                                                            _vm.$v.certificate
                                                              .post.country,
                                                            "required"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Field is required"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm.isCountryHasRegions(
                                                        _vm.certificate.post
                                                          .country
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "address-item",
                                                              class: {
                                                                "is-loading":
                                                                  _vm
                                                                    .loadingStatus
                                                                    .regions,
                                                                required: true,
                                                                "field-error":
                                                                  _vm.$v
                                                                    .certificate
                                                                    .post.region
                                                                    .$error
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "small grey"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Region"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .certificate
                                                                          .post
                                                                          .region,
                                                                      expression:
                                                                        "certificate.post.region"
                                                                    }
                                                                  ],
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm
                                                                        .loadingStatus
                                                                        .regions
                                                                  },
                                                                  on: {
                                                                    change: [
                                                                      function(
                                                                        $event
                                                                      ) {
                                                                        var $$selectedVal = Array.prototype.filter
                                                                          .call(
                                                                            $event
                                                                              .target
                                                                              .options,
                                                                            function(
                                                                              o
                                                                            ) {
                                                                              return o.selected
                                                                            }
                                                                          )
                                                                          .map(
                                                                            function(
                                                                              o
                                                                            ) {
                                                                              var val =
                                                                                "_value" in
                                                                                o
                                                                                  ? o._value
                                                                                  : o.value
                                                                              return val
                                                                            }
                                                                          )
                                                                        _vm.$set(
                                                                          _vm
                                                                            .certificate
                                                                            .post,
                                                                          "region",
                                                                          $event
                                                                            .target
                                                                            .multiple
                                                                            ? $$selectedVal
                                                                            : $$selectedVal[0]
                                                                        )
                                                                      },
                                                                      _vm.$v
                                                                        .certificate
                                                                        .post
                                                                        .region
                                                                        .$touch
                                                                    ]
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      attrs: {
                                                                        value:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "Select region"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._l(
                                                                    _vm.regions[
                                                                      _vm
                                                                        .certificate
                                                                        .post
                                                                        .country
                                                                    ],
                                                                    function(
                                                                      region,
                                                                      index
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key: index,
                                                                          domProps: {
                                                                            value:
                                                                              region.code
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              region.name
                                                                            ) +
                                                                              "\n                                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm.hasError(
                                                                _vm.$v
                                                                  .certificate
                                                                  .post.region,
                                                                "required"
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "error"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "Field is required"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "address-item width100",
                                                          class: {
                                                            required: true,
                                                            "field-error":
                                                              _vm.$v.certificate
                                                                .post.city
                                                                .$error
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "small grey"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("City")
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .certificate
                                                                    .post.city,
                                                                expression:
                                                                  "certificate.post.city"
                                                              }
                                                            ],
                                                            attrs: {
                                                              type: "text"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.certificate
                                                                  .post.city
                                                            },
                                                            on: {
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .certificate
                                                                      .post,
                                                                    "city",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                _vm.$v
                                                                  .certificate
                                                                  .post.city
                                                                  .$touch
                                                              ]
                                                            }
                                                          }),
                                                          _vm.hasError(
                                                            _vm.$v.certificate
                                                              .post.city,
                                                            "required"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Field is required"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "address-item",
                                                          class: {
                                                            required: true,
                                                            "field-error":
                                                              _vm.$v.certificate
                                                                .post.street
                                                                .$error
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "small grey"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Street address"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .certificate
                                                                    .post
                                                                    .street,
                                                                expression:
                                                                  "certificate.post.street"
                                                              }
                                                            ],
                                                            attrs: {
                                                              type: "text"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.certificate
                                                                  .post.street
                                                            },
                                                            on: {
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .certificate
                                                                      .post,
                                                                    "street",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                _vm.$v
                                                                  .certificate
                                                                  .post.street
                                                                  .$touch
                                                              ]
                                                            }
                                                          }),
                                                          _vm.hasError(
                                                            _vm.$v.certificate
                                                              .post.street,
                                                            "required"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Field is required"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "address-item",
                                                          class: {
                                                            required: true,
                                                            "field-error":
                                                              _vm.$v.certificate
                                                                .post.postcode
                                                                .$error
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "small grey"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Postcode"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .certificate
                                                                    .post
                                                                    .postcode,
                                                                expression:
                                                                  "certificate.post.postcode"
                                                              }
                                                            ],
                                                            attrs: {
                                                              type: "text"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.certificate
                                                                  .post.postcode
                                                            },
                                                            on: {
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .certificate
                                                                      .post,
                                                                    "postcode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                _vm.$v
                                                                  .certificate
                                                                  .post.postcode
                                                                  .$touch
                                                              ]
                                                            }
                                                          }),
                                                          _vm.hasError(
                                                            _vm.$v.certificate
                                                              .post.postcode,
                                                            "required"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Field is required"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "address-item",
                                                          class: {
                                                            required: true,
                                                            "field-error":
                                                              _vm.$v.certificate
                                                                .post.phone
                                                                .$error
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "small grey"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Phone"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .certificate
                                                                    .post.phone,
                                                                expression:
                                                                  "certificate.post.phone"
                                                              }
                                                            ],
                                                            attrs: {
                                                              type: "text"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.certificate
                                                                  .post.phone
                                                            },
                                                            on: {
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .certificate
                                                                      .post,
                                                                    "phone",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                _vm.$v
                                                                  .certificate
                                                                  .post.phone
                                                                  .$touch
                                                              ]
                                                            }
                                                          }),
                                                          _vm.hasError(
                                                            _vm.$v.certificate
                                                              .post.phone,
                                                            "required"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Field is required"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm.certificate.send ===
                                                    "email" &&
                                                  variant.type === "email"
                                                ? _c(
                                                    "wa-field",
                                                    {
                                                      class: {
                                                        required: true,
                                                        "hide-name":
                                                          _vm.settings
                                                            .is_frontend &&
                                                          field.name === "",
                                                        "field-error":
                                                          _vm.$v.certificate
                                                            .email.$error
                                                      },
                                                      attrs: {
                                                        name: _vm.settings
                                                          .is_frontend
                                                          ? variant.name
                                                          : _vm.$t("Email"),
                                                        hide_name:
                                                          _vm.settings
                                                            .is_frontend &&
                                                          variant.name === "",
                                                        hide_name_class:
                                                          "width100"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.certificate
                                                                .email,
                                                            expression:
                                                              "certificate.email"
                                                          }
                                                        ],
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value:
                                                            _vm.certificate
                                                              .email
                                                        },
                                                        on: {
                                                          input: [
                                                            function($event) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.certificate,
                                                                "email",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                            _vm.$v.certificate
                                                              .email.$touch
                                                          ]
                                                        }
                                                      }),
                                                      _vm.hasError(
                                                        _vm.$v.certificate
                                                          .email,
                                                        "required"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Field is required"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.hasError(
                                                        _vm.$v.certificate
                                                          .email,
                                                        "email"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Incorrect email"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                : _vm.certificate.send ===
                                                    "user" &&
                                                  !_vm.settings.is_frontend &&
                                                  variant.type === "user"
                                                ? _c(
                                                    "wa-field",
                                                    {
                                                      class: {
                                                        required: true,
                                                        "field-error":
                                                          _vm.$v.certificate
                                                            .contact_id.$error
                                                      },
                                                      attrs: {
                                                        name: _vm.$t("User")
                                                      }
                                                    },
                                                    [
                                                      _c("v-autocomplete", {
                                                        class: {
                                                          "is-loading":
                                                            _vm.loadingStatus
                                                              .autocomplete
                                                        },
                                                        attrs: {
                                                          items:
                                                            _vm.autocompleteUserItems,
                                                          "get-label": function(
                                                            item
                                                          ) {
                                                            if (item) {
                                                              return item.name
                                                            }
                                                          },
                                                          "min-len": 2,
                                                          "component-item":
                                                            _vm.autocompleteTemplate,
                                                          "auto-select-one-item": false,
                                                          "input-attrs": {
                                                            class: "width100",
                                                            placeholder: _vm.$t(
                                                              "Start typing user name or email"
                                                            )
                                                          }
                                                        },
                                                        on: {
                                                          "update-items":
                                                            _vm.updateAutocompleteItems
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.certificate
                                                              .contact_id,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.certificate,
                                                              "contact_id",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "certificate.contact_id"
                                                        }
                                                      }),
                                                      _vm.hasError(
                                                        _vm.$v.certificate
                                                          .contact_id,
                                                        "required"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Field is required"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.hasError(
                                                        _vm.$v.certificate
                                                          .contact_id,
                                                        "contact"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm.serverErrors
                                                                .contact_id &&
                                                              _vm.serverErrors
                                                                .contact_id
                                                                .message.length
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                                            " +
                                                                        _vm._s(
                                                                          _vm.serverErrors.contact_id.message.join(
                                                                            ", "
                                                                          )
                                                                        ) +
                                                                        "\n                                        "
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Select the correct contact"
                                                                        )
                                                                      )
                                                                    )
                                                                  ])
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "mb top"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Certificate will be available only for selected user"
                                                                )
                                                              ) +
                                                              "\n                                    "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                field.system_code === "products" &&
                                _vm.settings.is_frontend
                                  ? _c("the-free-products", {
                                      class:
                                        ((_obj$2 = {}),
                                        (_obj$2[field.css_class] =
                                          _vm.settings.is_frontend),
                                        _obj$2),
                                      attrs: {
                                        settings: _vm.settings,
                                        certificate: _vm.certificate,
                                        field: field
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      !_vm.settings.is_frontend
                        ? _c(
                            "wa-field",
                            { attrs: { name: _vm.$t("Use limitations") } },
                            [
                              _c("base-checkbox", {
                                attrs: { checked: _vm.isUseLimitations },
                                model: {
                                  value: _vm.certificate.use_limitations,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.certificate,
                                      "use_limitations",
                                      $$v
                                    )
                                  },
                                  expression: "certificate.use_limitations"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.certificate.use_limitations &&
                      !_vm.settings.is_frontend
                        ? _c(
                            "div",
                            [
                              _c(
                                "wa-field",
                                {
                                  staticClass: "mb top double",
                                  attrs: { name: _vm.$t("Expired") }
                                },
                                [
                                  _vm.certificate.id
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.disabled.expired,
                                            expression: "disabled.expired"
                                          }
                                        ],
                                        staticClass: "mb right",
                                        attrs: {
                                          type: "checkbox",
                                          "true-value": false,
                                          "false-value": true
                                        },
                                        domProps: {
                                          checked: !_vm.disabled.expired,
                                          value: true,
                                          checked: Array.isArray(
                                            _vm.disabled.expired
                                          )
                                            ? _vm._i(
                                                _vm.disabled.expired,
                                                true
                                              ) > -1
                                            : _vm._q(
                                                _vm.disabled.expired,
                                                false
                                              )
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.disabled.expired,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? false : true
                                            if (Array.isArray($$a)) {
                                              var $$v = true,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.disabled,
                                                    "expired",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.disabled,
                                                    "expired",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.disabled,
                                                "expired",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _c("base-datepicker", {
                                    attrs: {
                                      locale: _vm.settings.locale,
                                      disabled: _vm.disabled.expired
                                    },
                                    model: {
                                      value:
                                        _vm.certificate.limitations.expired,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.certificate.limitations,
                                          "expired",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "certificate.limitations.expired"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "wa-field",
                                { attrs: { name: _vm.$t("Lifetime") } },
                                [
                                  _vm.certificate.id
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.disabled.lifetime,
                                            expression: "disabled.lifetime"
                                          }
                                        ],
                                        staticClass: "mb right",
                                        attrs: {
                                          type: "checkbox",
                                          "true-value": false,
                                          "false-value": true
                                        },
                                        domProps: {
                                          checked: !_vm.disabled.lifetime,
                                          value: true,
                                          checked: Array.isArray(
                                            _vm.disabled.lifetime
                                          )
                                            ? _vm._i(
                                                _vm.disabled.lifetime,
                                                true
                                              ) > -1
                                            : _vm._q(
                                                _vm.disabled.lifetime,
                                                false
                                              )
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.disabled.lifetime,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? false : true
                                            if (Array.isArray($$a)) {
                                              var $$v = true,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.disabled,
                                                    "lifetime",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.disabled,
                                                    "lifetime",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.disabled,
                                                "lifetime",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value:
                                          _vm.certificate.limitations.lifetime,
                                        expression:
                                          "certificate.limitations.lifetime",
                                        modifiers: { number: true }
                                      }
                                    ],
                                    attrs: {
                                      type: "number",
                                      disabled: _vm.disabled.lifetime
                                    },
                                    domProps: {
                                      value:
                                        _vm.certificate.limitations.lifetime
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.certificate.limitations,
                                          "lifetime",
                                          _vm._n($event.target.value)
                                        )
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$tc(
                                          "{$n} days",
                                          _vm.certificate.limitations.lifetime
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                  _c("div", { staticClass: "gray mb top" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Number of days the certificate will be active after creating."
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "wa-field",
                                {
                                  attrs: {
                                    name: _vm.$t(
                                      "Maximal sum, which can be spent"
                                    )
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: _vm.certificate.limitations.max,
                                        expression:
                                          "certificate.limitations.max",
                                        modifiers: { number: true }
                                      }
                                    ],
                                    attrs: { type: "number" },
                                    domProps: {
                                      value: _vm.certificate.limitations.max
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.certificate.limitations,
                                          "max",
                                          _vm._n($event.target.value)
                                        )
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    " % " +
                                      _vm._s(
                                        _vm.$t(
                                          "from total price of order without shipping price"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "wa-field",
                                {
                                  attrs: { name: _vm.$t("Minimal order sum") }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value:
                                          _vm.certificate.limitations.min.value,
                                        expression:
                                          "certificate.limitations.min.value",
                                        modifiers: { number: true }
                                      }
                                    ],
                                    attrs: { type: "number" },
                                    domProps: {
                                      value:
                                        _vm.certificate.limitations.min.value
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.certificate.limitations.min,
                                          "value",
                                          _vm._n($event.target.value)
                                        )
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  }),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.certificate.limitations.min
                                              .currency,
                                          expression:
                                            "certificate.limitations.min.currency"
                                        }
                                      ],
                                      staticClass: "inherit",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.certificate.limitations.min,
                                            "currency",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    _vm._l(_vm.settings.currencies, function(
                                      currency,
                                      index
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: currency.code }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(currency.sign) +
                                              " " +
                                              _vm._s(currency.code) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _c("div", { staticClass: "gray mb top" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Minimal total price of order, from which certificate can be applied."
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.settings.is_frontend
                        ? _c(
                            "wa-field",
                            { attrs: { name: _vm.$t("Number of usage") } },
                            [
                              _c("div", { staticClass: "mb bottom" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.certificate.usage.type,
                                        expression: "certificate.usage.type"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      name: "usage_type",
                                      value: "disposable"
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.certificate.usage.type,
                                        "disposable"
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.certificate.usage,
                                          "type",
                                          "disposable"
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("disposable")) +
                                      "\n                            "
                                  )
                                ]),
                                _c("div", { staticClass: "gray" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "The certificate will be disposable."
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "mb bottom" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.certificate.usage.type,
                                        expression: "certificate.usage.type"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      name: "usage_type",
                                      value: "multiple"
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.certificate.usage.type,
                                        "multiple"
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.certificate.usage,
                                          "type",
                                          "multiple"
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("multiple")) +
                                      "\n                            "
                                  )
                                ]),
                                _c("div", { staticClass: "gray" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "The certificate can be used multiple times."
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.certificate.id
                    ? _c(
                        "div",
                        [
                          _c("hr"),
                          _c(
                            "wa-field",
                            { attrs: { name: _vm.$t("Certificate template") } },
                            [
                              _c("div", { staticClass: "mb bottom" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.certificate.template_type,
                                      expression: "certificate.template_type"
                                    }
                                  ],
                                  staticClass: "mb right",
                                  attrs: {
                                    type: "radio",
                                    name: "template_type",
                                    value: "default"
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.certificate.template_type,
                                      "default"
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.certificate,
                                        "template_type",
                                        "default"
                                      )
                                    }
                                  }
                                }),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.certificate.default_template,
                                        expression:
                                          "certificate.default_template"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        _vm.certificate.template_type =
                                          "default"
                                      },
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.certificate,
                                          "default_template",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  _vm._l(
                                    _vm.settings.system_settings.templates,
                                    function(template, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: index }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(template.name) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]),
                              _c(
                                "label",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.certificate.template_type = "custom"
                                    }
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.certificate.template_type,
                                        expression: "certificate.template_type"
                                      }
                                    ],
                                    staticClass: "mb right",
                                    attrs: {
                                      type: "radio",
                                      name: "template_type",
                                      value: "custom"
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.certificate.template_type,
                                        "custom"
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.certificate,
                                          "template_type",
                                          "custom"
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "base-modal",
                                    {
                                      attrs: {
                                        text: _vm.$t(
                                          "edit the template of the current certificate"
                                        ),
                                        title: _vm.$t(
                                          "Editing certificate template"
                                        ),
                                        component: _vm.editTemplateComponent,
                                        componentParams: {
                                          id: "common",
                                          url: this.settings.urls.get_template,
                                          postData: {
                                            id: _vm.certificate.id
                                          },
                                          revertLink: {
                                            title: _vm.$t(
                                              "revert to default template"
                                            ),
                                            url: this.settings.urls
                                              .revert_template,
                                            template_id:
                                              _vm.certificate.default_template
                                          }
                                        },
                                        saveData: _vm.certificate,
                                        buttons: {
                                          submit: {
                                            id: "edit-template-submit",
                                            name: _vm.$t("Save"),
                                            saveUrl: this.settings.urls
                                              .save_template,
                                            onPreSave: _vm.updateEditor
                                          }
                                        },
                                        waitComponentLoaded: true
                                      },
                                      on: {
                                        "update:saveData": function($event) {
                                          _vm.certificate = $event
                                        },
                                        "update:save-data": function($event) {
                                          _vm.certificate = $event
                                        }
                                      }
                                    },
                                    [_vm._v(" \n                            ")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.settings.is_frontend
                    ? _c("the-free-products", {
                        attrs: {
                          settings: _vm.settings,
                          certificate: _vm.certificate,
                          field: {}
                        }
                      })
                    : _vm._e(),
                  _c("hr"),
                  (_vm.certificate.send === "email" ||
                    _vm.certificate.send === "user") &&
                  !_vm.settings.is_backend_order_edit &&
                  !_vm.settings.is_frontend
                    ? _c(
                        "div",
                        { staticClass: "field clear-both" },
                        [
                          _c("base-checkbox", {
                            attrs: {
                              checked: parseInt(
                                _vm.certificate.send_notification
                              ),
                              label: _vm.$t(
                                "Send notification to person who the certificate is intended for"
                              )
                            },
                            model: {
                              value: _vm.certificate.send_notification,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.certificate,
                                  "send_notification",
                                  $$v
                                )
                              },
                              expression: "certificate.send_notification"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  typeof _vm.serverErrors.common !== "undefined"
                    ? _c(
                        "div",
                        { staticClass: "clear-both error-block" },
                        _vm._l(_vm.serverErrors.common.message, function(
                          error,
                          index
                        ) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(error) +
                                "\n                    "
                            )
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "mb top double clear-both" },
                    [
                      _c("base-submit-block", {
                        attrs: {
                          saveUrl:
                            this.settings.urls.save_certificate +
                            (!this.settings.is_frontend
                              ? _vm.settings.order_id || 0
                              : ""),
                          button: _vm.$t("Save"),
                          data: _vm.certificate,
                          onValidate: _vm.validateDataBeforeSubmit,
                          options: {
                            successStatus:
                              !_vm.certificate.id &&
                              !_vm.settings.is_backend_order &&
                              !_vm.settings.is_backend_order_edit
                                ? 1
                                : 2,
                            hideErrors: true
                          }
                        },
                        on: {
                          "update:data": function($event) {
                            _vm.certificate = $event
                          },
                          "pre-save": function($event) {
                            _vm.serverErrors = {}
                          },
                          saved: _vm.onSaved
                        }
                      }),
                      _vm.certificate.id
                        ? _c(
                            "div",
                            { staticClass: "align-right" },
                            [
                              _c(
                                "base-modal",
                                {
                                  attrs: {
                                    text:
                                      "<i class='icon16 delete'></i> " +
                                      _vm.$t("remove certificate"),
                                    title: _vm.$t("Are you sure?"),
                                    saveData: [_vm.certificate.id],
                                    buttons: {
                                      submit: {
                                        name: _vm.$t("Delete"),
                                        saveUrl: this.settings.urls
                                          .remove_certificate,
                                        options: {
                                          statesText: {
                                            reloading:
                                              _vm.$t(
                                                "Removed successfully. Page is reloading"
                                              ) + "..."
                                          },
                                          buttonClass: "red",
                                          reloadOnSuccess: true,
                                          redirectUrl:
                                            _vm.settings.app_url +
                                            (_vm.settings.is_old_ss
                                              ? "?plugin=giftcertificates"
                                              : "marketing/giftcertificates/"),
                                          successStatus: 1
                                        }
                                      }
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Do you really want to remove the certificate?"
                                      )
                                    ) + "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : Object.keys(_vm.responseOnHideAll).length
            ? _c("div", [
                _vm.settings.is_backend_order_edit
                  ? _c("div", [
                      _c("p", { staticClass: "is-loading mb left" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Wait, please, certificate is loading"))
                        )
                      ])
                    ])
                  : _vm.settings.is_frontend
                  ? _c("div", { staticClass: "successfull-message" }, [
                      _vm.responseOnHideAll.message
                        ? _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.responseOnHideAll.message)
                            }
                          })
                        : _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "The certificate was successfully created and added to the cart."
                                )
                              )
                            )
                          ])
                    ])
                  : _c("div", [
                      _c("p", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                _vm.settings.app_url +
                                (_vm.settings.is_old_ss
                                  ? "?plugin=giftcertificates&id="
                                  : "marketing/giftcertificates/") +
                                _vm.responseOnHideAll.id
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Certificate")))]
                        ),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("was created successfully.")) +
                            "\n                    "
                        )
                      ]),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("Code:")) + " "),
                        _c("b", [_vm._v(_vm._s(_vm.responseOnHideAll.code))])
                      ])
                    ])
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }